import axios from 'src/utils/axios';
import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  filter: false,
  logs: [],
  activities: [],
  printerLogs: [],
  haveErrorLogs: false,
  error: null
};

const slice = createSlice({
  name: 'logs',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET LOGS
    getLogsSuccess(state, action) {
      state.logs = action.payload;
    },

    getPrinterLogsSuccess(state, action) {
      state.printerLogs = action.payload;
    },

    setHaveErrorLogs(state, action) {
      state.haveErrorLogs = action.payload;
    },

    //
    filterLogsByDate(state, action) {
      state.filter = action.payload;
      state.logs = state.logs.filter(
        (l) => l.date >= action.payload.start && l.date <= action.payload.end
      );
    },

    filterUpdate(state, action) {
      state.filter = action.payload;
    },

    GetActivitiesSuccess(state, action) {
      state.activities = action.payload;
    },
    cleanLogs(state) {
      state.logs = [];
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getLogsSuccess,
  filterLogsByDate,
  filterUpdate,
  getPrinterLogsSuccess,
  setHaveErrorLogs,
  GetActivitiesSuccess,
  cleanLogs
} = slice.actions;

// ----------------------------------------------------------------------

export function GetLogs() {
  return async (dispatch) => {
    try {
      var response = await axios.get(`logs`);
      dispatch(getLogsSuccess(response.data));
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function GetActivities() {
  return async (dispatch) => {
    try {
      var response = await axios.get(`logs/GetActivity`);
      dispatch(GetActivitiesSuccess(response.data));
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function GetPrinterLogs() {
  return async (dispatch) => {
    try {
      var response = await axios.get(`logs/printer`);
      dispatch(getPrinterLogsSuccess(response.data));
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
